import { render } from "./IQTest.vue?vue&type=template&id=36fdee07&scoped=true"
import script from "./IQTest.vue?vue&type=script&lang=js"
export * from "./IQTest.vue?vue&type=script&lang=js"

import "./IQTest.vue?vue&type=style&index=0&id=36fdee07&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-36fdee07"

export default script